module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/max-level-100.fbe7e62e.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/max-level-100.png
// module id = 2567
// module chunks = 11